import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from 'common/components/ErrorBoundary';

import HeaderContainer from './HeaderContainer';
import BodyContainer from './BodyContainer';
import FooterContainer from './FooterContainer';

import AgeGateModal from 'apps/age_gate/components/AgeGateModal';

class AgeGateModalContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: true,
    };

    this.headerComponent = this.headerComponent.bind(this);
    this.bodyComponent = this.bodyComponent.bind(this);
    this.footerComponent = this.footerComponent.bind(this);
  }

  handleModalClose = () => this.setState({ isModalOpen: false });

  headerComponent() {
    const { configurations } = this.props;

    return <HeaderContainer configurations={configurations.header} />;
  }

  bodyComponent() {
    const { configurations, ageGateUIPolicy, ageGateTPActions } = this.props;

    return (
      <BodyContainer
        configurations={configurations.body}
        ageGateUIPolicy={ageGateUIPolicy}
        ageGateTPActions={ageGateTPActions}
        callbacks={{
          onAgreeButtonClick: this.handleModalClose,
        }}
      />
    );
  }

  footerComponent() {
    const { configurations, ageGateTPActions } = this.props;

    return (
      <FooterContainer
        configurations={configurations.footer}
        ageGateTPActions={ageGateTPActions}
      />
    );
  }

  render() {
    return (
      this.state.isModalOpen && (
        <ErrorBoundary>
          <AgeGateModal
            isModalOpen={this.state.isModalOpen}
            onRequestClose={this.handleModalClose}
            headerComponent={this.headerComponent}
            bodyComponent={this.bodyComponent}
            footerComponent={this.footerComponent}
          />
        </ErrorBoundary>
      )
    );
  }
}

AgeGateModalContainer.propTypes = {
  configurations: PropTypes.shape({
    header: PropTypes.shape({
      mission: PropTypes.bool,
      age_requirement: PropTypes.object,
    }),
    body: PropTypes.shape({
      agree: PropTypes.oneOfType([
        PropTypes.shape({
          disable_for_blocked_states: PropTypes.bool,
          route_to_locator_for_blocked_states: PropTypes.bool,
          trigger_state_pricing: PropTypes.bool,
        }),
        PropTypes.bool,
      ]),
      disagree: PropTypes.bool,
      blocked_state_warning: PropTypes.bool,
      minimum_age: PropTypes.number,
      selector: PropTypes.oneOfType([
        PropTypes.shape({
          states: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.string,
              label: PropTypes.string,
            })
          ),
        }),
        PropTypes.bool,
      ]),
    }),
    footer: PropTypes.shape({
      av_required: PropTypes.bool,
      language_selector: PropTypes.shape({
        languages: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
          })
        ),
      }),
      reseller_warning: PropTypes.bool,
      warranty_support: PropTypes.bool,
    }),
    properties: PropTypes.shape({
      is_warranty_enabled: PropTypes.bool,
    }),
    windowPath: PropTypes.string,
    geolocation: PropTypes.object,
  }),
  ageGateUIPolicy: PropTypes.object,
  ageGateTPActions: PropTypes.object,
};

export default AgeGateModalContainer;
